export default class NoteHelper {
    static noteStringToFrequency(value) {
        let octave = NoteHelper.extractOctave(value);
        let noteNumber = NoteHelper.notes.indexOf(value.slice(0, -1)) + 3;
        noteNumber = noteNumber + ((octave - 1) * 12) + 1;
        return 440 * Math.pow(2, (noteNumber - 49) / 12);
    }
    static distanceBetweenNotes(note1, note2) {
        let notePosition1 = NoteHelper.noteStringToNoteNumber(note1);
        let notePosition2 = NoteHelper.noteStringToNoteNumber(note2);
        return notePosition1 - notePosition2;
    }
    static noteNumberToNoteString(value) {
        if (value < 0) {
            throw new RangeError("Note value cannot be less than 0");
        }
        let note = NoteHelper.notes[value % 12];
        let octave = Math.floor(value / 12);
        return note + octave.toString();
    }
    static noteStringToNoteNumber(value) {
        return (NoteHelper.extractOctave(value) * 12) + NoteHelper.notes.indexOf(value.slice(0, -1));
    }
    static extractOctave(note) {
        if (note.length == 2) {
            return parseInt(note.charAt(1));
        }
        else if (note.length === 3) {
            return parseInt(note.charAt(2));
        }
        else {
            throw new RangeError("String is invalid (incorrect length): " + note);
        }
    }
}
NoteHelper.notes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
//# sourceMappingURL=NoteHelper.js.map